import html from "./SurveyModal.html"
import "../../../modal.css"
import "./SurveyModal.css"
import "../SurveyStep.js"
import { getBrowser } from "../../../helpers/MyDataHelps/participantDeviceInfo";
import { stampSurveyColorScheme } from "../../../helpers/surveyColorScheme";
import appActionHandler from "../../../helpers/appActionHandler"
import React from 'react';
import { createRoot } from 'react-dom/client';
import SurveyRuntimeInspector from '../../../components/SurveyAdministration/SurveyRuntimeInspector/SurveyRuntimeInspector';

var module = angular.module("ResearchKitApplicationModule");

module.component('surveyModal', {
	template: html,
	bindings: {
		surveyManager: '<',
		isConsent: '<',
		platforms: '<',
		// Set only by hosts whose survey should follow its own scheme. Coordinator
		// entry and intake both leave it unset so they stay in the designer's light
		// chrome — intake cannot be told apart by isCoordinatorEntered, which it
		// sets false only to hide the Save and Close button.
		colorSchemeSetting: '<'
	},
	controller: 'surveyModalController',
	controllerAs: 'vm'
});

module.controller("surveyModalController", ["$element", "$scope", "$document", "$window", "$timeout",
	function ($element, $scope, $document, $window, $timeout) {
		var vm = this;
		vm.loading = true;
		vm.inspectorOpen = false;


		vm.browser = getBrowser();

		vm.showLoading = function () {
			return vm.loading || (vm.surveyManager && vm.surveyManager.finishing);
		}

		// The survey stamps its own resolved scheme here, overriding the app
		// <body>'s project scheme underneath the modal.
		var removeSurveyColorScheme = null;

		// While the survey (and its scheme setting) is still loading, mirror the
		// app's scheme so opening a survey in a dark app does not flash a light
		// card. Tracked like a real stamp, so the survey's own stamp replaces it
		// the moment the survey is known — and a survey whose host passes no
		// setting drops back to unstamped (light) when its manager arrives.
		if (document.body.classList.contains("color-scheme-dark")) {
			removeSurveyColorScheme = stampSurveyColorScheme($element[0], "Dark");
		}

		function applySurveyColorScheme(manager) {
			if (removeSurveyColorScheme) {
				removeSurveyColorScheme();
				removeSurveyColorScheme = null;
			}
			if (manager && vm.colorSchemeSetting !== undefined) {
				removeSurveyColorScheme = stampSurveyColorScheme($element[0], vm.colorSchemeSetting);
			}
		}

		vm.$onChanges = function (changesObj) {
			if (changesObj.surveyManager) {
				applySurveyColorScheme(changesObj.surveyManager.currentValue);
				if (changesObj.surveyManager.currentValue) {
					$("body").addClass("no-scroll");
					vm.loading = false;
				}
				else if (changesObj.surveyManager.previousValue) {
					vm.loading = true;
				}
			}
			if (changesObj.platforms && changesObj.platforms.currentValue) {
				vm.loading = false;
			}
		};

		var inspectorRoot = null;
		var elementFocusedBeforeOpen = null;

		vm.$onDestroy = function () {
			applySurveyColorScheme(null);
			$("body").removeClass("no-scroll");

			$window.clearInterval(vm.fitOverlayInterval);
			$window.clearInterval(vm.fitNavValidationModalInterval);

			$document.off("keydown", handleKeydown);

			if (inspectorRoot) {
				inspectorRoot.unmount();
				inspectorRoot = null;
			}

			$element.remove();

			// Removing the modal drops focus to the top of the page, so put it back
			// on whatever opened the survey.
			if (elementFocusedBeforeOpen && elementFocusedBeforeOpen !== $document[0].body
				&& $document[0].contains(elementFocusedBeforeOpen)) {
				elementFocusedBeforeOpen.focus();
			}
		};

		function findVisibleFocusable(parent) {
			return parent
				.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]:not(.rk-modal-focus-sentinel)')
				.filter(":visible");
		}

		function handleKeydown(event) {
			var focusableElements = findVisibleFocusable($element);

			switch (event.keyCode) {
				case $.ui.keyCode.TAB:
					//Focus trap e.g. https://hidde.blog/using-javascript-to-trap-focus-in-an-element/
					if (elementToFocusOnNextTab) {
						setTimeout(function () {
							if (elementToFocusOnNextTab) {
								elementToFocusOnNextTab.focus();
								elementToFocusOnNextTab = null;
							}
						});
						break;
					}

					if (focusableElements.length === 0) {
						event.preventDefault();
						break;
					}

					// When focus is outside the modal or on its container, the next Tab
					// would land on the page behind the overlay — capture it instead.
					if (!$element[0].contains($document[0].activeElement) ||
						$document[0].activeElement === $element.find(".rk-modal")[0]) {
						event.preventDefault();
						focusableElements[event.shiftKey ? focusableElements.length - 1 : 0].focus();
						break;
					}

					if (event.shiftKey) {
						if ($document[0].activeElement === focusableElements.get(0)) {
							event.preventDefault();
							focusableElements[focusableElements.length - 1].focus();
						}
					} else {
						if ($document[0].activeElement === focusableElements.get(focusableElements.length - 1)) {
							event.preventDefault();
							focusableElements[0].focus();
						}
					}
					break;
				case $.ui.keyCode.ESCAPE:
					$scope.$apply(function () {
						vm.finishSurvey();
					});
					break;
				default:
					break;
			}
		}

		var elementToFocusOnNextTab;

		vm.$postLink = function () {
			$element.appendTo("body");

			/* 
			 * Runtime calculated fields inspector are manually mounted.
			 * Using react-component directive would create a dependency on all designer components for participans (who use this module)
			 * Using survey-react-component does not work as it relies on having a survey step context, which is not present here.
			*/
			var inspectorContainer = document.createElement('div');
			$element[0].appendChild(inspectorContainer);
			// Keep the sentinel last so forward Tab reaches the inspector before it.
			$element.append($element.find(".rk-modal-focus-sentinel"));
			inspectorRoot = createRoot(inspectorContainer);

			var currentSnapshots = null;
			function renderInspector() {
				inspectorRoot.render(
					React.createElement(SurveyRuntimeInspector, {
						onOpenChange: function (isOpen) {
							$scope.$apply(function () {
								vm.inspectorOpen = isOpen;
							});
						},
						calculatedFieldSnapshots: currentSnapshots
					})
				);
			}
			renderInspector();

			$scope.$on("calculatedFieldsEvaluated", function (event, snapshots) {
				currentSnapshots = snapshots;
				renderInspector();
			});

			function fitOverlay() {
				var overlayHeight = $element.find(".current-survey").height() + 80;
				var windowHeight = $($window).height();
				if (windowHeight > overlayHeight) {
					overlayHeight = windowHeight;
				}
				$element.find(".current-survey-overlay").height(overlayHeight);
			}
			vm.fitOverlayInterval = $window.setInterval(fitOverlay, 500);

			var modal = $element.find(".rk-modal");

			// Take focus from the trigger, which may sit in an embedded-view iframe
			// where the keydown trap cannot see Tab.
			elementFocusedBeforeOpen = $document[0].activeElement;
			modal.focus();

			$element.find(".rk-modal-focus-sentinel").on("focus", function () {
				var focusableElements = findVisibleFocusable(modal);
				if (focusableElements.length) {
					focusableElements.first().focus();
				}
			});

			$scope.$on("setStep", function () {
				$timeout(function () {
					calculateShowScrollMarker();
					modal.scrollTop(0);
					elementToFocusOnNextTab = findVisibleFocusable(modal.find(".current-step")).first();
				}, 100);
			});

			$scope.$on("refocus", function () {
				$timeout(function () {
					findVisibleFocusable(modal.find(".current-step")).first().focus();
					setTimeout(function () {
						modal.scrollTop(0);
					}, 0);
				});
			});

			function calculateShowScrollMarker() {
				if (vm.surveyManager) {
					vm.surveyManager.currentStepManager.showScrollMarker = modal.scrollTop() + modal.outerHeight() < modal[0].scrollHeight;
				}
			}

			var throttledOnScroll = _.throttle(function () {
				$scope.$apply(calculateShowScrollMarker);
			}, 150);

			modal.on("scroll", throttledOnScroll);

			modal.on("focusin", function () {
				elementToFocusOnNextTab = null;
			});

			var screenChangeEvents = "webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange";
			$document.on(screenChangeEvents, function () {
				var fullScreenElement = $document[0].fullscreenElement || $document[0].mozFullScreenElement || $document[0].webkitFullscreenElement || $document[0].msFullscreenElement;
				// Note: iframe check is necessary for full-screening video in iframe
				if (fullScreenElement && fullScreenElement.tagName === "IFRAME") {
					return;
				}
				if (fullScreenElement) {
					$element.appendTo($(fullScreenElement));
				} else {
					$element.appendTo($("body"));
				}
			});

			$document.on("keydown", handleKeydown);
		};

		vm.getCssClass = function () {
			if (!vm.surveyManager || vm.surveyManager.getMode() !== "Design") {
				return "survey-mode";
			}
			return "";
		};

		vm.finishSurvey = function () {
			$scope.$emit('surveyFinished');
		};

		$scope.$on("cancelSurvey", function () {
			if (vm.surveyManager) vm.surveyManager.close();
			else vm.finishSurvey();
		});

		$scope.$on("androidBackButtonPressed", function () {
			$scope.$apply(function () {
				if (!vm.surveyManager?.managedStepIdentifiers || vm.surveyManager.managedStepIdentifiers.length <= 1) {
					//if at the beginning of the survey, close it
					vm.loading = true;
					vm.surveyManager = null;
					// Direct vm assignment does not fire $onChanges, so clean up here.
					applySurveyColorScheme(null);
					appActionHandler.surveyFinished("Closed", null);
				}
				else if (vm.surveyManager.currentStepManager) {
					//rely on the step manager back(); because steps may embed specific behavior into the back button
					//e.g. consent steps have "sub-steps"
					vm.surveyManager.currentStepManager.back();
				}
			});
		});
	}]);
